import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "../../Components/customComponents/customTextField";
import { usaEmployeeSlice } from "../../store/reducers/usaEmployeeSlice";
import Select from "../../Components/customComponents/customSelect";
import FileUploadComponent from "../../Components/customComponents/customUpload";
import { upload_file_to_s3 } from "../../utils";


const UsaPersonalDetails = ({
  personalDetailsError,
  setPersonalDetailsError,
  change,
  isfilled,
  isInvite,
}) => {
  const dispatch = useDispatch();

  const state = useSelector(
    (state) => state.usaEmployee.intialUsEmployee.personalDetails
  );

  const feildsDisabled = useSelector(
    (state) => state.usaEmployee.feildsDisabled
  );

  const [docLoader, setDocLoader] = useState({
    ssnDocumentV1: false,
    drivingLicenseDocumentV1: false,
    passportDocumentV1: false,
  });

  const onchange = (e, directory) => {
    let { name, value } = e.target;

    if (name === "ssn") {
      if (/[^0-9-]/.test(value) && value !== "") return;

      value = formatSSN(value);

      if (value.length < 9 && value.length !== 0) {
        const temp = { ...personalDetailsError };
        temp[name] = "SSN should be 9 digits";
        setPersonalDetailsError(temp);
      } else {
        const temp = { ...personalDetailsError };
        temp[name] = "";
        setPersonalDetailsError(temp);
      }
    } else if (name === "passportNumber") {
      // Allow 1 alphabet followed by up to 7 digits (e.g. A1234567)
      if (value !== "" && !/^[A-Za-z][0-9]*$/.test(value)) return;

      if (value.length > 8) return;

      const error =
        value !== "" && !/^[A-Za-z][0-9]{7}$/.test(value)
          ? "Must be 1 letter + 7 digits"
          : "";

      const temp = { ...personalDetailsError };
      temp[name] = error;
      setPersonalDetailsError(temp);
    } else if (name === "dob") {
      const date = new Date(value);
      value = date.toISOString();
    } else if (name === "email") {
      value = value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value) && value !== "") {
        setPersonalDetailsError({
          ...personalDetailsError,
          [name]: "Invalid email address",
        });
      } else {
        setPersonalDetailsError({
          ...personalDetailsError,
          [name]: "",
        });
      }
    }

    dispatch(
      usaEmployeeSlice.actions.updateDetails({
        name,
        value,
        directory,
      })
    );
  };

  const formatSSN = (value) => {
    let numericValue = value.replace(/\D/g, "");

    if (numericValue.length > 9) {
      numericValue = numericValue.slice(0, 9);
    }

    return numericValue.replace(
      /(\d{3})(\d{3})(\d{3})/,
      "$1-$2-$3"
    );
  };

  const handleNewUpload = async (new_file, label) => {
    const filename = new_file?.target?.name || "";
    const files = Array.from(new_file?.target?.files || []);
    if (files.length === 0) return;

    try {
      setDocLoader((prev) => ({ ...prev, [filename]: true }));

      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      const maxSize = 5 * 1024 * 1024;
      const uploadedFiles = [];

      for (const file of files) {
        // File type validation
        if (!allowedTypes.includes(file.type)) {
          alert("Only PDF, PNG, JPG files are allowed");
          continue;
        }
        // File size validation
        if (file.size > maxSize) {
          alert("File size should be less than 5MB");
          continue;
        }

        const s3path = await upload_file_to_s3(file);
        uploadedFiles.push({
          fileName: filename,
          name: file.name,
          resourceName: label,
          uploadDate: new Date().toISOString(),
          comment: "",
          extension: file.name.split(".").pop(),
          s3Document: {
            ...(s3path?.data?.data || {}),
            originalFileName: file.name,
          },
        });
      }

      const existing = Array.isArray(state?.[filename]) ? state[filename] : [];

      dispatch(
        usaEmployeeSlice.actions.updateDetails({
          name: filename,
          value: [...existing, ...uploadedFiles],
          directory: "personalDetails",
        })
      );

      setDocLoader((prev) => ({ ...prev, [filename]: false }));
    } catch (error) {
      console.error("File upload failed:", error);
      setDocLoader((prev) => ({ ...prev, [filename]: false }));
    }
  };

  const handleRemoveDoc = (filename, index) => {
    const existing = Array.isArray(state?.[filename]) ? state[filename] : [];
    const updated = existing.filter((_, i) => i !== index);
    dispatch(
      usaEmployeeSlice.actions.updateDetails({
        name: filename,
        value: updated,
        directory: "personalDetails",
      })
    );
  };

  return (
    <div className="ml-10 mb-9">
      <p className="font-medium">PERSONAL DETAILS</p>

      <div className="flex flex-col justify-evenly p-6 items-end justify-self-start">
        <TextField
          label={"Email"}
          type={"email"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={isInvite || feildsDisabled}
          name={"email"}
          value={state.email}
          error={personalDetailsError.email}
          className={`${!state.email && isfilled && "border border-red-500"}`}
        />

        {/* SSN */}
        <TextField
          label={"SSN(Social Security Number)"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"ssn"}
          value={state.ssn}
          error={personalDetailsError.ssn}
          className={`${!state.ssn && isfilled && "border border-red-500"}`}
        />

        <FileUploadComponent
          name={"ssnDocumentV1"}
          label={"Upload SSN Document"}
          handleUploade={(e) => handleNewUpload(e, "SSN Document")}
          isMandatory={true}
          isMultiple={true}
          isDisabled={feildsDisabled}
          files={Array.isArray(state.ssnDocumentV1) ? state.ssnDocumentV1 : []}
          onRemove={(i) => handleRemoveDoc("ssnDocumentV1", i)}
        />

        {/* Driving License */}
        <TextField
          label={"Driving License"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"drivingLicense"}
          value={state.drivingLicense}
          className={`${
            !state.drivingLicense && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <FileUploadComponent
          name={"drivingLicenseDocumentV1"}
          label={"Upload Driving License"}
          handleUploade={(e) => handleNewUpload(e, "Driving License Document")}
          isMandatory={true}
          isMultiple={true}
          isDisabled={feildsDisabled}
          files={
            Array.isArray(state.drivingLicenseDocumentV1)
              ? state.drivingLicenseDocumentV1
              : []
          }
          onRemove={(i) => handleRemoveDoc("drivingLicenseDocumentV1", i)}
        />

        {/* Passport */}
        <TextField
          label={"Passport Number"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"passportNumber"}
          value={state.passportNumber}
          error={personalDetailsError.passportNumber}
          className={`${
            !state.passportNumber && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <FileUploadComponent
          name={"passportDocumentV1"}
          label={"Upload Passport Document"}
          handleUploade={(e) => handleNewUpload(e, "Passport Document")}
          isMandatory={true}
          isMultiple={true}
          isDisabled={feildsDisabled}
          files={
            Array.isArray(state.passportDocumentV1)
              ? state.passportDocumentV1
              : []
          }
          onRemove={(i) => handleRemoveDoc("passportDocumentV1", i)}
        />

        {/* Gender */}
        <Select
          label={"Gender"}
          isMandatory={true}
          name={"gender"}
          value={state.gender}
          onChange={(e) => onchange(e, "personalDetails")}
          options={[
            { label: "MALE", value: "MALE" },
            { label: "FEMALE", value: "FEMALE" },
            {
              label: "DO NOT WANT TO DISCLOSE",
              value: "DO_NOT_WANT_TO_DISCLOSE",
            },
          ]}
          disabled={feildsDisabled}
          className={`${
            !state.gender && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        {/* DOB */}
        <TextField
          label={"Date Of Birth"}
          type={"date"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"dob"}
          value={state.dob ? state.dob.slice(0, 10) : ""}
          max={new Date().toISOString().split("T")[0]}
          className={`${!state.dob && isfilled && "border border-red-500"}`}
        />

        {/* Emergency Contact */}
        <TextField
          label={"Emergency Contact Name"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"emergencyContactName"}
          value={state.emergencyContactName}
        />

        <TextField
          label={"Relation"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"emergencyContactRelation"}
          value={state.emergencyContactRelation}
        />

        <TextField
          label={"Address"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "personalDetails")}
          disabled={feildsDisabled}
          name={"emergencyContactAddress"}
          value={state.emergencyContactAddress}
        />
      </div>
    </div>
  );
};

export default UsaPersonalDetails;